var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(2 2)",
    fill: "#DDF6ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7981 6.31295C14.9934 6.50821 14.9934 6.8248 14.7981 7.02006L8.687 13.1312C8.59323 13.2249 8.46605 13.2776 8.33344 13.2776C8.20083 13.2776 8.07366 13.2249 7.97989 13.1312L5.20211 10.3534C5.00685 10.1581 5.00685 9.84155 5.20211 9.64628C5.39737 9.45102 5.71396 9.45102 5.90922 9.64628L8.33344 12.0705L14.091 6.31295C14.2863 6.11769 14.6028 6.11769 14.7981 6.31295Z",
    fill: "#009C64"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 18,
    height: 18,
    rx: 1,
    stroke: "#009C64",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.d1cd176a4505b288b36086a03c9e469a.svg";
export { ForwardRef as ReactComponent };